import VExportPaymentBaseTotalItem from "../Domain/VExportPaymentBaseTotalItem.js";
import AuthService from "./authService.js";

export default class VExportPaymentBaseTotalsService {
  static ConvertDBItems(itemlist) {
    if (itemlist !== null) {
      return itemlist.map((item) => new VExportPaymentBaseTotalItem(item));
    }

    return [];
  }

  static GetListByExportId(p1, p2, p3, p4, item) {
    const authService = AuthService.getInstance();
    const url = `/api/VExportPaymentBaseTotals/GetListByExportId/${item.exportId}?clearCache=false`;
    return authService.CallBackendFunction(url);
  }
}
